export const ROUTES = {
    // Public
    HOME: '/',
    LOGIN: '/login',
    REGISTER: '/register',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    /** Forced replacement of a temporary (new or admin-reset) password. */
    CHANGE_PASSWORD: '/change-password',

    // Dashboard (legacy)
    DASHBOARD: '/dashboard',
    DASHBOARD_HELP: '/dashboard/help',

    // Export (one route per authenticated shell; the server scopes the content)
    MEMBER_EXPORT: '/member/export',
    PILLAR_CHAIR_EXPORT: '/pillar-chair/export',
    PROJECT_MANAGER_EXPORT: '/project-manager/export',
    TASK_FORCE_CHAIR_EXPORT: '/task-force-chair/export',
    EXECUTIVE_EXPORT: '/executive/export',
    ADMIN_EXPORT: '/admin/export',

    // Structure (one route per authenticated shell; the server roots the tree)
    MEMBER_STRUCTURE: '/member/structure',
    PILLAR_CHAIR_STRUCTURE: '/pillar-chair/structure',
    PROJECT_MANAGER_STRUCTURE: '/project-manager/structure',
    TASK_FORCE_CHAIR_STRUCTURE: '/task-force-chair/structure',
    EXECUTIVE_STRUCTURE: '/executive/structure',
    ADMIN_STRUCTURE: '/admin/structure',

    // User Manual (one route per authenticated shell)
    MEMBER_HELP: '/member/help',
    PILLAR_CHAIR_HELP: '/pillar-chair/help',
    PILLAR_CHAIR_WEEKLY_REPORT: '/pillar-chair/weekly-report',
    PROJECT_MANAGER_WEEKLY_REPORT: '/project-manager/weekly-report',
    PROJECT_MANAGER_HELP: '/project-manager/help',
    TASK_FORCE_CHAIR_HELP: '/task-force-chair/help',
    EXECUTIVE_HELP: '/executive/help',
    ADMIN_HELP: '/admin/help',

    // Member
    MEMBER: '/member',
    PILLAR_CHAIR: '/pillar-chair',
    PILLAR_CHAIR_OPERATIONAL_DASHBOARD: '/pillar-chair/operational-dashboard',
    PROJECT_MANAGER: '/project-manager',
    PILLAR_CHAIR_PROJECTS: '/pillar-chair/projects',
    PILLAR_CHAIR_PROJECT_DETAIL: (projectId = ':projectId') => `/pillar-chair/projects/${projectId}`,
    PILLAR_CHAIR_LOCATIONS: '/pillar-chair/locations',
    PILLAR_CHAIR_ESCALATION_HISTORY: '/pillar-chair/escalation-history',
    TASK_FORCE_CHAIR: '/task-force-chair',
    TASK_FORCE_CHAIR_OPERATIONAL_DASHBOARD: '/task-force-chair/operational-dashboard',
    EXECUTIVE: '/executive',
    EXECUTIVE_OPERATIONAL_DASHBOARD: '/executive/operational-dashboard',
    ADMIN: '/admin',
    MEMBER_TASKS: '/member/tasks',
    MEMBER_ESCALATION_HISTORY: '/member/escalation-history',
    ADMIN_ACCOUNTS: '/admin/accounts',
    ADMIN_PILLAR_CHAIRS: '/admin/pillar-chairs',
    ADMIN_PROJECT_MANAGERS: '/admin/project-managers',
    ADMIN_MEMBERS: '/admin/members',
    MEMBER_TASK_DETAIL: (id = ':id') => `/member/tasks/${id}`,

    TASK_FORCE_CHAIR_PILLARS: '/task-force-chair/pillars',
    TASK_FORCE_CHAIR_PILLAR_DETAIL: (pillarId = ':pillarId') => `/task-force-chair/pillar/${pillarId}`,
    TASK_FORCE_CHAIR_MY_TASK_FORCE: '/task-force-chair/my-task-force',
    TASK_FORCE_CHAIR_ESCALATION_HISTORY: '/task-force-chair/escalation-history',
    EXECUTIVE_DASHBOARD: '/executive',
    EXECUTIVE_TASK_FORCE: (tfId = ':tfId') => `/executive/task-force/${tfId}`,
    EXECUTIVE_TASK_FORCE_PILLAR: (tfId = ':tfId', pillarId = ':pillarId') => `/executive/task-force/${tfId}/${pillarId}`,
    PROJECT_MANAGER_ESCALATION_HISTORY: '/project-manager/escalation-history',
    PROJECT_MANAGER_OPERATIONAL_INDICATORS: '/project-manager/operational-indicators',
    PROJECT_MANAGER_REGISTRATION_CONFIRMATION: '/project-manager/registration-confirmation',
    ADMIN_DASHBOARD: '/admin',
    ADMIN_TASK_FORCES: '/admin/task-forces',
    ADMIN_TASK_FORCE_CHAIRS: '/admin/task-force-chairs',
    ADMIN_EXECUTIVES: '/admin/executives',
    ADMIN_ADMINISTRATORS: '/admin/administrators',

    // Delivery hierarchy, admin-scoped: the same management pages the role
    // dashboards use, but an admin picks the entity instead of being pinned to
    // their own (all task forces / all pillars / all projects).
    ADMIN_PILLARS: '/admin/pillars',
    ADMIN_PROJECTS: '/admin/projects',
    ADMIN_TASKS: '/admin/tasks',

    ADMIN_USERS: '/admin/users',
    ADMIN_ROLES: '/admin/roles',
    ADMIN_CITIES: '/admin/cities',
    ADMIN_ORGANIZATIONS: '/admin/organizations',
    ADMIN_NOTIFICATION_MANAGEMENT: '/admin/notification-management',
    ADMIN_AUTO_ESCALATION: '/admin/auto-escalation',
    ADMIN_COUNTDOWN: '/admin/countdown',
    ADMIN_OPERATIONAL_INDICATORS: '/admin/operational-indicators',
    ADMIN_REGISTRATION_CONFIRMATION: '/admin/registration-confirmation',
    ADMIN_OPERATIONAL_DASHBOARD_VIEWERS: '/admin/operational-dashboard-viewers',
    ADMIN_AUDIT_LOGS: '/admin/audit-logs',
    ADMIN_IMPORT: '/admin/import',
    ADMIN_IMPORT_USERS: '/admin/import/users',
    ADMIN_IMPORT_ORGANIZATIONS: '/admin/import/organizations',
    ADMIN_IMPORT_TASKS: '/admin/import/tasks',

    // Workstreams
    WORKSTREAMS: '/workstreams',
    WORKSTREAM_DETAIL: (id = ':id') => `/workstreams/${id}`,
    WORKSTREAM_CREATE: '/workstreams/new',

    // Settings
    SETTINGS: '/settings',
    SETTINGS_PROFILE: '/settings/profile',
    SETTINGS_SECURITY: '/settings/security',
    SETTINGS_PREFERENCES: '/settings/preferences',

    // Error pages
    NOT_FOUND: '/404',
    SERVER_ERROR: '/500',
};
